module.exports = __webpack_public_path__ + "img/DE03791.a1172907.png";